import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  useWorkflowBuilderContext,
  WorkflowBuilderProvider,
  WorkflowDto,
  WorkflowEditPanel
} from '@sierralabs/workflow-ui';
import WorkflowApiLevelLabel from '../workflow/components/WorkflowApiLevelLabel';

const WorkflowV2DetailPage: React.FC = () => {
  return (
    <WorkflowBuilderProvider>
      <WorkflowV2DetailPageRoot />
    </WorkflowBuilderProvider>
  );
};

const WorkflowV2DetailPageRoot: React.FC = () => {
  const { workflowId: paramWorkflowId = '' } = useParams<{
    workflowId?: string;
  }>();
  const workflowId = parseInt(paramWorkflowId) || 0;
  const { setSelectedWorkflow } = useWorkflowBuilderContext();

  useEffect(() => {
    const workflow = workflowId
      ? ({ id: workflowId } as WorkflowDto)
      : undefined;
    setSelectedWorkflow(workflow);
  }, [workflowId, setSelectedWorkflow]);

  return <WorkflowEditPanel status={<WorkflowApiLevelLabel apiLevel={2} />} />;
};

export default WorkflowV2DetailPage;
